import React, { forwardRef } from 'react';
import MobileResponsiveMenu from '../MobileResponsiveMenu';
import UpperHeader from './UpperHeader';
import '../../../assets/css/header.css';

const Header = forwardRef(({ toggleMenu, isMobile, menuVisible, menuOpen, setMenuOpen }, ref) => {
    return (
        <div className='header-container' ref={ref}>
            <UpperHeader />
            <MobileResponsiveMenu 
                toggleMenu={toggleMenu}
                isMobile={isMobile}
                menuVisible={menuVisible}
                isOpen={menuOpen}
                setIsOpen={setMenuOpen}
            />
        </div>
    );
});

// Add display name for better debugging
Header.displayName = 'Header';

export default Header;
